import type {LogModel} from './ActionRunLogModel.ts';

export type CollapsedAncestor =
  | {type: 'step'; step: number} |
  {type: 'group'; groupKey: string; step: number};

export function findFlatIndexForLine(model: LogModel, step: number, lineIndex: number): number {
  return model.getFlatIndexForKey(`${step}:${lineIndex}`);
}

export function findVisibleIndexForFlatIndex(model: LogModel, flatIndex: number): number {
  if (flatIndex < 0) return -1;
  const target = model.getFlat()[flatIndex];
  if (!target) return -1;
  return model.getVisible().findIndex((it) => it.key === target.key);
}

// Pure: does not mutate model state. Caller expands the returned ancestor (if any) via
// model.setStepExpanded/setGroupExpanded -- awaiting any data fetch a step expansion triggers
// -- then re-resolves via findVisibleIndexForFlatIndex.
export function collapsedAncestorsFor(model: LogModel, flatIndex: number): CollapsedAncestor[] {
  const flat = model.getFlat();
  const target = flat[flatIndex];
  if (!target || target.kind === 'step-header') return [];
  if (!model.isStepExpanded(target.step)) return [{type: 'step', step: target.step}];
  for (let i = flatIndex - 1; i >= 0; i--) {
    const item = flat[i];
    if (item.kind === 'step-header' || item.step !== target.step) break;
    if (item.cmd?.name === 'group') {
      const span = model.getGroupSpan(item.key);
      const stillEnclosing = span && (span.endFlatIndex === null || span.endFlatIndex > flatIndex);
      if (stillEnclosing && !model.isGroupExpanded(item.key)) {
        return [{type: 'group', groupKey: item.key, step: target.step}];
      }
      break; // the nearest group-start above the target is the only candidate enclosing group
    }
  }
  return [];
}
